import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const ExpeditionRouteMarker = ({
  width = 11,
  height = 14,
  fill = colors.dark,
  opacity = 1,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11 14"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        opacity={opacity}
        ref={forwardRef}
        d="M1.89413 1.60253C2.86932 0.644585 4.19197 0.106445 5.57109 0.106445C6.95022 0.106445 8.27287 0.644585 9.24806 1.60253C10.2233 2.56043 10.7711 3.85971 10.7711 5.21441C10.7711 9.10576 6.06746 12.8485 5.86418 13.0064C5.78073 13.0712 5.67747 13.1064 5.57109 13.1064C5.46472 13.1064 5.36147 13.0712 5.27801 13.0064C5.26991 12.9993 5.25256 12.9849 5.22683 12.9635C4.68171 12.5107 0.371094 8.93033 0.371094 5.21441C0.371094 3.85971 0.918939 2.56043 1.89413 1.60253ZM5.57109 7.32984C6.8019 7.32984 7.79967 6.35964 7.79967 5.16282C7.79967 3.96601 6.8019 2.9958 5.57109 2.9958C4.34029 2.9958 3.34252 3.96601 3.34252 5.16282C3.34252 6.35964 4.34029 7.32984 5.57109 7.32984Z"
      />
    </svg>
  )
}

export default ExpeditionRouteMarker
